/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ViewProperty.AffordableSetup.Programs.AHP.Title',
    defaultMessage: 'AHP',
  },
});

export default messages;
